import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'slug',
    standalone: false
})
export class SlugPipe implements PipeTransform {
  transform(input: string): string {
    return input.toString().toLowerCase()
      .replace(/ä/g, 'ae') // Replace umlauts
      .replace(/ö/g, 'oe') // Replace umlauts
      .replace(/ü/g, 'ue') // Replace umlauts
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  }
}
